module.exports = __webpack_public_path__ + "static/img/yuanmou_zhongyi_icon.645e4c81.png";